import { render, staticRenderFns } from "./laiyuandi.vue?vue&type=template&id=7a351ab4&scoped=true&"
import script from "./laiyuandi.vue?vue&type=script&lang=js&"
export * from "./laiyuandi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a351ab4",
  null
  
)

export default component.exports